import { apiService } from './api'
import { QuestionReport, CreateQuestionReportRequest } from '../types/questionReport'

interface GetReportsResponse {
  reports: QuestionReport[]
  pagination: {
    page: number
    limit: number
    total: number
    pages: number
  }
}

interface CreateReportResponse {
  message: string
  report: QuestionReport
}

interface GetReportCountResponse {
  count: number
}

interface DeleteReportResponse {
  message: string
}

export class QuestionReportService {
  /**
   * 設問通報を登録
   */
  static async createReport(data: CreateQuestionReportRequest): Promise<CreateReportResponse> {
    return await apiService.post<CreateReportResponse>('/question-reports', data)
  }

  /**
   * 通報一覧を取得（管理者用）
   */
  static async getReports(params?: { page?: number; limit?: number }): Promise<GetReportsResponse> {
    return await apiService.get<GetReportsResponse>('/question-reports', params)
  }

  /**
   * 通報件数を取得（ダッシュボード用）
   */
  static async getReportCount(): Promise<GetReportCountResponse> {
    return await apiService.get<GetReportCountResponse>('/question-reports/count')
  }

  /**
   * 通報を削除（管理者用）
   */
  static async deleteReport(id: string): Promise<DeleteReportResponse> {
    return await apiService.delete<DeleteReportResponse>(`/question-reports/${id}`)
  }
}
